import { render, staticRenderFns } from "./DonateButton.vue?vue&type=template&id=7d6ffa1a&scoped=true"
import script from "./DonateButton.vue?vue&type=script&lang=js"
export * from "./DonateButton.vue?vue&type=script&lang=js"
import style0 from "./DonateButton.vue?vue&type=style&index=0&id=7d6ffa1a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6ffa1a",
  null
  
)

export default component.exports